import { useQuery } from "@tanstack/react-query";
import { getLectureMaterials } from "../../../../services/dashboard/apiLecture";

export function useMaterials({ courseId, lectureId, page, perPage } = {}) {
  const { data: materials, isPending } = useQuery({
    queryKey: ["lectureMaterials", courseId, lectureId, page, perPage],
    queryFn: () =>
      getLectureMaterials({
        courseId,
        lectureId,
        apiOperations: { page, perPage },
      }),
  });

  return { isPending, materials };
}
